<template>
  <CustomerSiteHeader v-if="showSiteHeader" />
  <router-view />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import CustomerSiteHeader from '@/components/CustomerSiteHeader.vue'

const route = useRoute()

const showSiteHeader = computed(() => {
  return !['Login', 'Register', 'AdminPanel', 'AgentsCenter', 'AgentDetail'].includes(String(route.name || ''))
})
</script>

<style>
#app {
  width: 100%;
  height: 100vh;
  margin: 0;
  padding: 0;
}

*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
